import { defaultPresets } from 'utils/relativeDateTime';
import BasePanel from './BasePanel';
import { PresetListContainer, PresetItem } from './PresetsPanel.styled';

// type Props = {
//   /** The relative start date/time range. */
//   startRange: string,
//   /** The relative end date/time range. */
//   endRange: string,
//   /** Callback function when date/time range changes. */
//   onRangeChange: () => void,
//   /** List of presets to show. */
//   presets: [],
// };

const defaultProps = {
  presets: defaultPresets,
};

const PresetsPanels = (props) => {
  const { startRange, endRange, onRangeChange, presets } = props;

  /**
   * createPreset
   * Creates a preset link.
   * @param { Object } preset: Th epreset object containing the start range, end range and label.
   * @param { String } key: Key of the preset since this is generated in a loop.
   * @returns { React.Component } The preset link.
   */
  const createPreset = (preset, key) => {
    const { startRange: startRangeFormat, endRange: endRangeFormat, label } = preset;
    const isSelected = startRange === startRangeFormat && endRange === endRangeFormat;

    /**
     * handleClick
     * Callback function when a preset is clicked.
     * @return { void }
     */
    const handleClick = () => {
      onRangeChange({
        startRange: startRangeFormat,
        endRange: endRangeFormat,
        label,
        closeOnChange: true,
      });
    };

    return (
      <PresetItem key={key} onClick={handleClick} data-selected={isSelected}>
        {label}
      </PresetItem>
    );
  };

  return (
    <BasePanel title="Presets" {...props}>
      <PresetListContainer>
        {Object.keys(presets).map((key, index) => createPreset(presets[key], `${key} - ${index}`))}
      </PresetListContainer>
    </BasePanel>
  );
};

export default PresetsPanels;
PresetsPanels.defaultProps = defaultProps;
